import React from "react";

import styles from "./Spinner.module.css";

type SpinnerProps = {
	/** Already-translated wording for what is loading; announced and, by default, shown. */
	label: string;
	/** Keeps the label for assistive technology only — for spinners with no room for text. */
	isLabelHidden?: boolean;
};

/**
 * Busy indicator for a region that is still loading.
 *
 * `role="status"` with `aria-live="polite"` announces the label once without interrupting, and
 * `aria-busy` marks the region as not yet settled. Callers place it; this only draws it.
 */
export const Spinner = ({ isLabelHidden = false, label }: SpinnerProps) => (
	<div aria-busy="true" aria-live="polite" className={styles.root} role="status">
		<span aria-hidden="true" className={styles.disc} />
		<span className={isLabelHidden ? "sr-only" : styles.label}>{label}</span>
	</div>
);
